var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-radio",
    {
      staticClass: "ml-4",
      attrs: {
        "native-value": _vm.option.value,
        name: _vm.name,
        type: _vm.option.type,
        size: "is-small",
      },
      model: {
        value: _vm.localValue,
        callback: function ($$v) {
          _vm.localValue = $$v
        },
        expression: "localValue",
      },
    },
    [_vm._v(" " + _vm._s(_vm.option.label) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }